import React from 'react';
import { DOCTOR_IMAGE } from '../../data/content';
import { TransformCTA } from '../TransformCTA';
export function About() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-54" data-mp="oqm5bqr6w7i1">
      <div className="mx-auto max-w-3xl" data-id="element-55" data-mp="12rf08clel4lo">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.25em] text-brandred" data-id="element-56" data-mp="12q3zymr62ezb">
          👩‍⚕️ Quién está detrás
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] leading-tight font-black tracking-tight text-navy sm:text-4xl" data-id="element-57" data-mp="az7n3m53wac1">
          Sobre la Dra. Karito
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy/10 bg-white md:flex" data-id="element-58" data-mp="5ytea1vokwcy">
          <img src={DOCTOR_IMAGE} alt="Retrato de la Dra. Karito, creadora de Ruta Anticoagulación" className="h-72 w-full object-cover object-top md:h-auto md:w-2/5" data-id="element-59" data-mp="jtvtjfmf3y2f" />
          <div className="p-6 md:w-3/5" data-id="element-60" data-mp="3jfsnwfnl3x42">
            <p className="text-[15px] leading-relaxed text-navy/70" data-id="element-61" data-mp="3jere0eib1gnx">
              Ruta Anticoagulación nace de una necesidad real:{' '}
              <strong className="font-bold text-navy" data-id="element-62" data-mp="337e33giijd9g">
                tomar decisiones críticas con poco tiempo y sin margen de error.
              </strong>
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-navy/70" data-id="element-63" data-mp="3czjrkg9k3cjw">
              Este sistema fue creado para ese momento exacto en el que el paciente está frente a ti
              y necesitas decidir con claridad.
            </p>
            <p className="mt-5 font-display text-lg font-black italic text-brandred" data-id="element-64" data-mp="2p9h287x10koz">
              “Cada decisión cuenta.”
            </p>
            <p className="text-[12px] font-bold uppercase tracking-widest text-navy/40" data-id="element-65" data-mp="2u7ir59h4ve8d">
              — Dra. Karito
            </p>
          </div>
        </div>

        <TransformCTA text="Quiero el sistema creado por la Dra. Karito" data-id="element-66" data-mp="9il5y1qgvg3b" />
      </div>
    </section>;
}